import { useRecipeService } from "../Hooks/useRecipeService";
import { useUserContext } from "../Hooks/useUserContext";
import { NavigationDrawer } from "./NavigationDrawer";
import { RouterLink } from "../Shared/RouterLink";
import React, {
	useState
} from "react";
import {
	AppBar,
	Toolbar,
	IconButton,
	Typography,
	Snackbar,
	SnackbarContent,
	LinearProgress
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import RecipesIcon from "@material-ui/icons/Fastfood";
import AdminIcon from "@material-ui/icons/Security";
import UserAdminIcon from "@material-ui/icons/People";
import IngredientIcon from "@material-ui/icons/Kitchen";
import UnitEquivalentsIcon from "@material-ui/icons/Straighten"; // "@material-ui/icons/Balance"
import MetricConversionsIcon from "@material-ui/icons/SignalCellular0Bar"; // "@material-ui/icons/SquareFoot"
import UnitAppropriationsIcon from "@material-ui/icons/GraphicEq"; //"@material-ui/icons/Scale"
import TagAdminIcon from "@material-ui/icons/Label";
import LoginIcon from "@material-ui/icons/ArrowForward";
import LogoutIcon from "@material-ui/icons/ArrowBack";
import CreateRecipeIcon from "@material-ui/icons/Create";
import ImportRecipeIcon from "@material-ui/icons/GetApp";
import SendToKitchenIcon from "@material-ui/icons/Launch";
import SendingToKitchenIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";

export function Menu(props) {
	const recipeService = useRecipeService(props.config);
	const [isOpenDrawer, setIsOpenDrawer] = useState(false);
	const [isSendToKitchenOpen, setIsSendToKitchenOpen,] = useState(false);
	const [isExecutingSendToKitchen, setIsExecutingSendToKitchen] = useState(false);
	const user = useUserContext(props.config);

	const alwaysActions = [];

	const signedOutActions = [{
		text: "Login",
		url: "/login",
		icon: <LoginIcon />
	}];

	const sendToKitchen = () => {
		setIsExecutingSendToKitchen(true);
		setIsSendToKitchenOpen(true);
		recipeService.sendTo("kitchen", window.location.href, (response) => {
			if (response && response.status === 200 && response.data) {
				setTimeout(() => setIsSendToKitchenOpen(false), 3000);
			} else {
				setIsSendToKitchenOpen(false);
				console.log(response);
				alert(response.status);
			}

			setIsExecutingSendToKitchen(false);
		}, (error) => {
			setIsSendToKitchenOpen(false);
			console.log(error);
			if (error.response) {
				console.log(error.response);
				alert(error.response.status);
			}
			else {
				alert(error);
			}

			setIsExecutingSendToKitchen(false);
		});

		return false;
	};

	const signedInActions = [
		{
			text: "Recipes",
			url: "/recipes",
			icon: <RecipesIcon />
		},
		{
			text: "Create Recipe",
			url: "/recipes/create",
			icon: <CreateRecipeIcon />
		},
		{
			text: "Import Recipe",
			url: "/recipes/create?import=1",
			icon: <ImportRecipeIcon />
		},
		...(user.canSendToKitchen ? [
			"divider",
			{
				text: "Send to Kitchen",
				url: "#",
				onClick: sendToKitchen,
				icon: <SendToKitchenIcon />
			}] : []),
		...((user.isUserAdmin || user.isVolumeToMassAdmin || user.isUnitAdmin || user.isUnitAppropriationAdmin || user.isMetricConversionAdmin || user.isTagAdmin) ? [
			"divider",
			{
				text: "Admin",
				icon: <AdminIcon />,
				subItems: [
					...(user.isUserAdmin ? [
						{
							text: "Users",
							url: "/admin/users",
							icon: <UserAdminIcon />
						}] : []),
					...(user.isVolumeToMassAdmin ? [
						{
							text: "Volume to Mass Conversions",
							url: "/admin/volume-to-mass-conversions",
							icon: <IngredientIcon />
						}] : []),
					...(user.isUnitAdmin ? [
						{
							text: "Unit Equivalents",
							url: "/admin/unit-equivalents",
							icon: <UnitEquivalentsIcon />
						}] : []),
					...(user.isMetricConversionAdmin ? [
						{
							text: "Metric Conversions",
							url: "/admin/metric-conversions",
							icon: <MetricConversionsIcon />
						}] : []),
					...(user.isUnitAppropriationAdmin ? [
						{
							text: "Unit Appropriations",
							url: "/admin/unit-appropriations",
							icon: <UnitAppropriationsIcon />
						}] : []),
					...(user.isTagAdmin ? [
						{
							text: "Tags",
							url: "/admin/tags",
							icon: <TagAdminIcon />
						}] : [])
				]
			}] : []),
		"divider",
		{
			text: "Logout",
			url: "/logout",
			icon: <LogoutIcon />
		}
	];

	function toggleDrawer() {
		setIsOpenDrawer(!isOpenDrawer);
	}

	return (
		<React.Fragment>
			<NavigationDrawer
				header="Recipe Book"
				className="no-print"
				isOpen={isOpenDrawer}
				toggleOpen={toggleDrawer}
				primaryActions={alwaysActions}
				// Don't show signed-out actions until we've initialized the user state to avoid
				// a flash of the login option during the initial auth check on page load.
				otherActions={user.isInitialized ? (user.isLoggedIn ? signedInActions : signedOutActions) : []} />
			<AppBar position="static" color="primary" className="no-print">
				<Toolbar>
					<IconButton color="inherit" onClick={toggleDrawer}>
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
						<RouterLink to="/" className="inherit-style" >
							Recipe Book
						</RouterLink>
					</Typography>
					{user.isInitialized && user.isLoggedIn ? (
						<Typography variant="h6" color="inherit">
							Hello, {user.firstName}!
						</Typography>
					) : null}
				</Toolbar>
			</AppBar>
			<SendToKitchenSnackBar
				open={isSendToKitchenOpen}
				setIsSendToKitchenOpen={setIsSendToKitchenOpen}
				isExecuting={isExecutingSendToKitchen}
			/>
		</React.Fragment>
	);
}

function SendToKitchenSnackBar(props) {
	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			open={props.open}
			autoHideDuration={8000}
			onClose={props.onClose}
			style={{ marginTop: 20 }}>
			<SnackbarContent
				style={{ backgroundColor: green[600] }}
				message={<div className="rb-snackbar-message">
					<SendingToKitchenIcon />
					<span style={{ paddingLeft: 10 }}>{props.isExecuting ? "Sending to kitchen..." : "This page has been sent to kitchen!"}</span>
					{props.isExecuting ? (<LinearProgress />) : (null)}
				</div>}
				action={<IconButton onClick={() => props.setIsSendToKitchenOpen(false)}>
					<CloseIcon />
				</IconButton>}
			/>
		</Snackbar>
	);
}
